var checkbox = "https://shopfront-cdn.tekoapis.com/static/2325f68c1e3eab10.svg";

export { checkbox as default };
